//create broadcast
export const CREATE_BROADCAST_REQUEST = "CREATE_BROADCAST_REQUEST";
export const CREATE_BROADCAST_RECEIVE = "CREATE_BROADCAST_RECEIVE";
export const CREATE_BROADCAST_FAILURE = "CREATE_BROADCAST_FAILURE";
export const RESET_CREATE_BROADCAST= "RESET_CREATE_BROADCAST";

//create private broadcast
export const CREATE_PRIVATE_BROADCAST_REQUEST = "CREATE_PRIVATE_BROADCAST_REQUEST";
export const CREATE_PRIVATE_BROADCAST_RECEIVE = "CREATE_PRIVATE_BROADCAST_RECEIVE";
export const CREATE_PRIVATE_BROADCAST_FAILURE = "CREATE_PRIVATE_BROADCAST_FAILURE";
export const RESET_CREATE_PRIVATE_BROADCAST= "RESET_CREATE_PRIVATE_BROADCAST";

//report broadcast
export const REPORT_BROADCAST_REQUEST = "REPORT_BROADCAST_REQUEST";
export const REPORT_BROADCAST_RECEIVE = "REPORT_BROADCAST_RECEIVE";
export const REPORT_BROADCAST_FAILURE = "REPORT_BROADCAST_FAILURE";
export const RESET_REPORT_BROADCAST= "RESET_REPORT_BROADCAST";

//update broadcaster status
export const UPDATE_BROADCASTER_REQUEST = "UPDATE_BROADCASTER_REQUEST";
export const UPDATE_BROADCASTER_RECEIVE = "UPDATE_BROADCASTER_RECEIVE";
export const UPDATE_BROADCASTER_FAILURE = "UPDATE_BROADCASTER_FAILURE";

//create availability
export const CREATE_AVAILABILITY_REQUEST = "CREATE_AVAILABILITY_REQUEST";
export const CREATE_AVAILABILITY_RECEIVE = "CREATE_AVAILABILITY_RECEIVE";
export const CREATE_AVAILABILITY_FAILURE = "CREATE_AVAILABILITY_FAILURE";
export const RESET_AVAILABILITY_BROADCAST= "RESET_AVAILABILITY_BROADCAST";